module.exports = __webpack_public_path__ + "media/application/images/projects/secondary_nav/testimonials-8e16a44fa582ff50c60f1e703fd3daeb.jpg";